<template>
    <div>
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <template v-if="Object.values(data).length">
            <h3 class="d-flex align-items-center justify-content-center mb-0 font-weight-bold text-center">
                {{ $t(`dashboard.${module}`) }}

                <span
                    v-if="tooltip"
                    v-tippy="{ content: tooltip }"
                    class="tooltip text-normal ml-2"
                >
                    <ui-icon icon="info" />
                </span>
            </h3>

            <figure
                class="
                    d-flex
                    align-items-center
                    justify-content-center
                    pt-4
                    pb-5
                    bg-transparent
                "
            >
                <img
                    :src="`/images/dashboard/widgets/${module}.svg`"
                    loading="lazy"
                >
            </figure>

            <p
                class="
                    py-25
                    px-4
                    px-lg-5
                    mx-n4
                    mx-lg-n5
                    font-weight-bold
                    text-center
                    border-top
                    border-bottom
                    bg-light
                "
            >
                {{ $t(`dashboard.${subtitle}`) }}
            </p>

            <ul class="list list-lined mb-n4">
                <li class="mx-n4 mx-lg-n5 px-4 px-lg-5">
                    <span>
                        {{ $t('dashboard.contestants') }}
                    </span>
                    <span class="font-weight-semi-bold">
                        {{ formatNumber(data['total_patients']) }}
                    </span>
                </li>
                <li class="mx-n4 mx-lg-n5 px-4 px-lg-5">
                    <span>
                        {{ $t('dashboard.start_value') }}
                    </span>
                    <span class="font-weight-semi-bold">
                        {{ formatNumber(data['start_average']) }}
                    </span>
                </li>
                <li class="mx-n4 mx-lg-n5 px-4 px-lg-5">
                    <span>
                        {{ $t('dashboard.improvement') }}
                    </span>
                    <span class="font-weight-semi-bold">
                        {{ formatNumber(data['total_patients_with_improvement']) }}
                    </span>
                </li>
                <li class="mx-n4 mx-lg-n5 px-4 px-lg-5">
                    <span>
                        {{ $t(`dashboard.${improvementTranslationKey}`) }}
                    </span>
                    <span class="font-weight-semi-bold">
                        {{ formatNumber(data['improvement_percentage']) }}%
                    </span>
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import UiSpinner from '../ui/spinner.vue';
import UiIcon from '../ui/icon.vue';

export default {
    name: 'WidgetScoreBlock',
    components: {
        UiSpinner,
        UiIcon,
    },
    props: {
        module: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        improvementTranslationKey: {
            type: String,
            required: true,
        },
        moduleKey: {
            type: String,
            required: true,
        },
        resultType: {
            type: String,
            required: true,
        },
        higherIsBetter: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            required: false,
        },
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: [],
            isLoading: true,
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...mapState('dashboard', [
            'query',
        ]),
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const { data: { data } } = await axios.get(this.url, { params: {
                    ...this.query,
                    module_key: this.moduleKey,
                    result_type: this.resultType,
                    higher_is_better: this.higherIsBetter ? 1 : 0,
                } });

            this.data = data;
            this.isLoading = false;
        },
    },
    watch: {
        query() {
            this.fetch();
        },
    },
};
</script>

<style lang="scss" scoped>
    .list-lined {
        li {
            padding-top: 16px;
            padding-bottom: 16px;

            &:last-child {
                font-weight: bold;
                background-color: $light;
            }
        }
    }

    img {
        height: 40px;
    }
</style>
